import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupC} gsapdGroupC`}>
            <div className="a-msg-box">
                <div className="msg-line-a1">{t('BMS')}</div>
                <div className="msg-line-a2">
                    {t.rich('BMS_title', {
                        line1: (child: any) => <div className="msg-line-a3">{child}</div>,
                    })}
                </div>
                <div className="msg-line-desc">{t('BMS_desc')}</div>
            </div>
            <div className="a-img-box">
                <EFVideo sources={['/video/deltamax/bms.webm', '/video/deltamax/bms.mp4']} />
            </div>
        </div>
    );
}
